import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Col, Grid, Row} from 'react-bootstrap';
import List from '../../points-statement/rewards-statement-list';

class RewardsStatement extends Component {
  state = {
    pageNumber: 1
  };

  handlePageChange = (page) => {
    const {dispatch, outlet, getListAction} = this.props;
    this.setState({pageNumber: page}, () => {
      dispatch(getListAction(outlet, page));
    });
  };

  componentWillMount() {
    const {dispatch, outlet, getListAction} = this.props;
    dispatch(getListAction(outlet));
  }

  render() {
    const {pageNumber} = this.state;
    const {
      fetching, fetched, pagination, list,
    } = this.props;

    return (
      <Grid bsClass="container" fluid className="points-statement">
        <Row>
          <Col md={12}>
            <List
              pointsStatements={list}
              fetching={fetching}
              fetched={fetched}
              pagination={pagination}
              onPageChange={this.handlePageChange}
              currentPage={pageNumber}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect()(RewardsStatement);



// WEBPACK FOOTER //
// ./src/components/team/points-activity/rewards-statement.jsx